import { type Accessor, type Component, For, Show } from 'solid-js'
import Button from '~/components/Button'
import EditorInput from '~/components/EditorInput'
import SwipeAction from '~/components/SwipeAction'

export interface ContenidoTabPropsType {
  content: Accessor<string>
  setContent: (value: string) => void
  steps: { title: string; description: string }[]
  openCreateStep: () => void
  openEditStep: (index: number) => void
  moveStep: (index: number, delta: number) => void
  removeStep: (index: number) => void
}

/** Pestaña Contenido: descripción larga y pasos de "Cómo trabajamos". */
const ContenidoTab: Component<ContenidoTabPropsType> = props => {
  return (
    <div class="space-y-8">
      <div>
        <h3 class="font-semibold text-foreground">Descripción larga</h3>
        <p class="text-xs text-foreground-subtle mb-3">Lo que se cuenta en la página pública: qué se hace, cómo y para quién. La descripción corta de General sigue siendo la de las tarjetas.</p>
        <EditorInput value={props.content()} onChange={props.setContent} placeholder="Cuenta en qué consiste, qué problemas resuelve y qué incluye…" minHeight="18rem" />
      </div>

      <div>
        <div class="flex flex-wrap items-center justify-between gap-3 mb-2">
          <div>
            <h3 class="font-semibold text-foreground">Cómo trabajamos</h3>
            <p class="text-xs text-foreground-subtle">Los pasos, en orden. Se pintan numerados en la página pública.</p>
          </div>
          <Button size="sm" variant="soft" color="default" onClick={props.openCreateStep} prependIcon="material-symbols-light:add">
            Añadir paso
          </Button>
        </div>

        <div class="space-y-2">
          <For each={props.steps}>
            {(step, index) => (
              <SwipeAction
                itemId={`step-${index()}`}
                rememberPosition
                onClick={() => props.openEditStep(index())}
                leftOptions={[
                  { icon: 'material-symbols-light:arrow-upward', action: () => props.moveStep(index(), -1), color: 'default', label: 'Subir' },
                  { icon: 'material-symbols-light:arrow-downward', action: () => props.moveStep(index(), 1), color: 'default', label: 'Bajar' }
                ]}
                rightOptions={[
                  { icon: 'material-symbols-light:edit-outline', action: () => props.openEditStep(index()), color: 'warning', label: 'Editar' },
                  { icon: 'material-symbols-light:delete-outline', action: () => props.removeStep(index()), color: 'danger', label: 'Eliminar' }
                ]}
              >
                <div class="flex items-start gap-3 rounded-lg border border-border p-3 bg-surface">
                  <span class="w-8 h-8 shrink-0 rounded-full bg-primary-soft text-primary flex items-center justify-center text-sm font-bold">{index() + 1}</span>
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-foreground truncate">{step.title || 'Sin título'}</p>
                    <Show when={step.description}>
                      <p class="text-sm text-foreground-subtle line-clamp-2">{step.description}</p>
                    </Show>
                  </div>
                </div>
              </SwipeAction>
            )}
          </For>

          <Show when={props.steps.length === 0}>
            <p class="text-sm text-foreground-subtle">Sin pasos. Útil sobre todo en servicios, para que el cliente sepa qué va a pasar.</p>
          </Show>
        </div>
      </div>
    </div>
  )
}

export default ContenidoTab
